module.exports = __webpack_public_path__ + "media/images/target-new-e6abb2f16e6ff53f29c73f37bdae679c.svg";